import React from 'react';

import { BodyL } from 'components/Typography/Typography';

import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/paymentMethodsStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

export const AccordionTitle = ({ title, suffixIcon }: { title: string; suffixIcon?: React.ReactNode }) => {
	const classes = useStyles();
	return (
		<div className={classes.accordionTitleContainer}>
			<div className={classes.accordionTitle}>
				<BodyL>{title}</BodyL>
				{suffixIcon}
			</div>
		</div>
	);
};

export const AccordionContent = ({ children }: { children: React.ReactNode }) => {
	const classes = useStyles();
	return <div className={classes.accordionElement}>{children}</div>;
};
